import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
    },
  }),
  { name: 'ItemsResource' }
);
